import React from 'react';
import './CompleteAndPostConfirmationModal.css';

const CompleteAndPostConfirmationModal = ({ handleClose, show, children, handleSave }) => {
  const showHideClassName = show ? "complete-and-post-modal display-block" : "complete-and-post-modal display-none";

  return (
    <div className={showHideClassName}>
        <div className ="complete-and-post-popup-background" onClick={handleClose}>
            <section className="complete-and-post-modal-main">
                <h1 className="complete-and-post-alert-text">Complete & Post</h1>
                {children}
                <div className="complete-and-post-button-container">
                    <h4 className="complete-and-post-text-cancel" onClick={handleClose}>Not right now</h4>
                    <button className="complete-and-post-button-modal" onClick={handleSave}>Yes, post!</button>
                </div>
            </section>
        </div>
    </div>
  );
};

export default CompleteAndPostConfirmationModal;